// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3x5hu","col":"styles_col__20ZuR"};